import {Component, Input} from '@angular/core';
import {SummaryEntityValue} from '@portal-workspace/grow-shared-library';
import { MatDividerModule } from '@angular/material/divider';
import { CellComponent } from './cell.component';


@Component({
    selector: 'entities-summary',
    template: `
    @for (entity of entities; track entity; let index = $index) {
      <!-- the first heading is spaced by the mt-3 wrapper the parent summary puts around us -->
      <div class="row" [class.mt-3]="index > 0">
        <div class="col-12">
          <div class="application-subsection-title">Entity {{index + 1}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6 col-md-12">
          <cell>
            <div label>Organisation</div>
            <div body>{{entity.name}}</div>
          </cell>
        </div>
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Organisation type</div>
            <div body>{{entity.organisationType}}</div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
      <div class="row">
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>ABN</div>
            <div body>{{entity.abn}}</div>
          </cell>
        </div>
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>ACN</div>
            <div body>{{entity.acn}}</div>
          </cell>
        </div>
        <div class="col-lg-3 col-md-12">
          <cell>
            <div label>Role</div>
            <div body>{{entity.role}}</div>
          </cell>
        </div>
      </div>
      <mat-divider [inset]="true"></mat-divider>
    }
    `,
    standalone: true,
    imports: [CellComponent, MatDividerModule]
})
export class EntitiesSummaryComponent {

  @Input({required: false}) entities?: SummaryEntityValue[] | null;

}
